module.exports = __webpack_public_path__ + "static/media/ed2.e43b482e.jpg";